<template>
  <fragment>
    <v-row class="mt-2" justify="center">
      <v-col cols="11">
        <v-text-field
          v-model.lazy.trim="agent.name"
          hide-details="auto"
          label="Agent Adı Soyadı"
          validate-on-blur
          dense
          :rules="[
            (v) => !!v || 'Ad Soyad alanı boş bırakılamaz',
            (v) =>
              v?.length >= 3 ||
              'Ad Soyad alanı en az 3 karakterden oluşmalıdır',
          ]"
          required
        ></v-text-field>
      </v-col>
      <v-col cols="11">
        <SMEmailTextField
          :email="agent.email"
          @update:email="(email) => (agent.email = email)"
          :user_id="agent.id"
        ></SMEmailTextField>
      </v-col>
      <v-col cols="11">
        <v-text-field
          v-model.lazy="agent.password"
          :rules="[
            (v) => !!v || 'Parola alanı boş bırakılamaz',
            (v) =>
              v?.length >= 8 || 'Parola alanı en az 8 karakterden oluşmalıdır',
          ]"
          label="Parola"
          type="password"
          required
        ></v-text-field>
      </v-col>
      <v-col cols="11">
        <SMPhoneSelectbox
          validatable
          :phone="agent.phone"
          :validate-id="null"
          @update:phone="(phone) => (agent.phone = phone)"
        ></SMPhoneSelectbox>
      </v-col>
      <!-- şirket telefonu -->
      <v-col cols="11" v-if="showCompanyPhone">
        <SMPhoneSelectbox
          validatable
          label="Agent Şirket Telefonu"
          :id="'company-phone-input'"
          :phone="agent.company_phone"
          :validate-id="null"
          @update:phone="(phone) => (agent.company_phone = phone)"
        ></SMPhoneSelectbox>
      </v-col>
    </v-row>
  </fragment>
</template>

<script>
import SMEmailTextField from "@/view/content/siliconmade/SM-Email-Textfield.vue";
import SMPhoneSelectbox from "@/view/content/siliconmade/SM-Phone-Selectbox.vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "CreateQuickAgent",
  components: {
    SMPhoneSelectbox,
    SMEmailTextField,
  },
  props: {
    agent: {
      type: Object,
      default: () => ({}),
    },
    showCompanyPhone: {
      type: Boolean,
      default: false,
    },
    isFormValid: {
      type: Boolean,
      default: true,
    },
  },
  created() {},
  watch: {
    agent: {
      handler() {
        this.$emit("update:agent", this.agent);
      },
      deep: true,
    },
  },
});
</script>
